export default __webpack_public_path__ + "assets/input.96414e63.svg";